import {makeRequest, makeRequestPut, makeRequestGet} from '../../Services/API';

export function getDadosDashboard(user, lang) {
    return makeRequest(`/backend/dashboard/${user}/${lang}`);
}

export function getClientes(indiceI, indiceF, lang) {
    let params = {
        indiceI: indiceI,
        indiceF: indiceF,
    };

    return makeRequest(`/backend/clientes/${lang}`, params);
}

export function getNegociosPorId(num, lang = 'POR') {
    let params = {
        id: num,
    };

    return makeRequest(`/backend/negocio/empresa/${lang}`, params);
}

export function postEtapas(num, data, etapa, motivo, terminoProjeto, lang = 'POR') {
    let params = [
        {
            num: num,
            data: data,
            etapa: etapa,
            motivo: motivo,
            terminoProjeto: terminoProjeto,
        },
    ];

    return makeRequest(`/backend/negocios/etapa/${lang}`, params);
}

export function postLinhas(id, nome, referencia, quantidade, preco, desconto, total, lang = 'POR') {
    let params = [
        {
            idLinha: id,
            nome: nome.value,
            referencia: referencia,
            quantidade: parseInt(quantidade),
            preco: parseInt(preco),
            iva: 0,
            desconto: parseInt(desconto),
            total: parseInt(total),
            totalPVP: 0,
        },
    ];
    return makeRequest(`/backend/linhasproposta/${lang}/Criar`, params);
}

export function getMecanicos(lang = 'POR') {
    return makeRequest(`/backend/mecanicos/${lang}`);
}

export function getReunioes(user, lang = 'POR') {
    return makeRequestGet(`/backend/negocios/reunioes/${lang}/${user}`);
}

export function postContacto(cliente, contacto, nome, apelido, lang = 'POR') {
    let params = {
        cliente: cliente,
        contacto: contacto,
        nome: nome,
        apelido: apelido,
    };
    return makeRequest(`/backend/negocios/Criar/contactos/${lang}`, params);
}

export function putReuniao(num, cliente, id, descricao, dataInicio, dataFim, horaInicio, horaFim, responsavel, estab, telemovel, categoria, lang = 'POR') {
    let params = [
        {
            id: id,
            num: num,
            cliente: cliente,
            descrição: descricao,
            dataI: dataInicio,
            dataF: dataFim,
            horaInicio: horaInicio,
            horaFim: horaFim,
            responsavel: responsavel,
            estabelecimento: estab,
            telemovel: telemovel,
            categoria: categoria,
        },
    ];
    return makeRequestPut(`/backend/negocios/reunioes/editar/${lang}`, params);
}

export function getDados(lang) {
    return makeRequest(`/backend/negocios/dados/${lang}`);
}

export function PostDadosContaPesquisa(pesquisa, lang = 'POR') {
    let params = [
        {
            pesquisa: pesquisa,
        },
    ];
    return makeRequest(`/backend/negocios/conta/${lang}`, params);
}

export function getNegociosId(idRecebido, lang) {
    let params = [
        {
            id: idRecebido,
            lang: lang,
        },
    ];
    return makeRequestGet(`/backend/getnegocio/${lang}?id=${idRecebido}`);
}

export function getReuniaoId(idRecebido, lang = 'POR') {
    let params = [
        {
            id: idRecebido,
        },
    ];
    return makeRequest(`/backend/negocios/reunioesID/${lang}`, params);
}

export function getClienteId(idRecebido, lang) {
    let params = {
        id: idRecebido,
    };

    return makeRequest(`/backend/clienteID/${lang}`, params);
}

export function putCliente(id, nome, nif, pais, lingua, divisa, enderecos, categoria, resp, origem, lang = 'POR') {
    let params = {
        codigoCliente: id,
        nomeCliente: nome,
        contribuinte: nif,
        pais: pais,
        lingua: lingua,
        divisa: divisa,
        enderecos: enderecos,
        categoria: categoria,
        resp: resp,
        origem: origem,
    };
    return makeRequestPut(`/backend/clientes/atualizar/${lang}`, params);
}

export function getClientesPesquisa(pesquisa, indiceI, indiceF, lang) {
    let params = {
        pesquisa: pesquisa,
        indiceI: indiceI,
        indiceF: indiceF,
    };
    return makeRequest(`/backend/clientes/pesquisa/${lang}`, params);
}

export function getClientesFiltros(pesquisa, indiceI, indiceF, lang) {
    let params = {
        pesquisa: pesquisa,
        indiceI: indiceI,
        indiceF: indiceF,
    };
    return makeRequest(`/backend/clientes/filtros/${lang}`, params);
}

export function getDadosAX(lang = 'POR') {
    return makeRequestGet(`/backend/cliente/dadosAX/${lang}`);
}

export function postCliente(nome, nif, categoria, morada, codPostal, cidade, contacto, email, pais, moeda, lingua, responsavel, ax6, ax7, lang = 'POR') {
    let params = {
        nomeCliente: nome,
        contribuinte: nif,
        categoria: categoria,
        morada: morada,
        codPostal: codPostal,
        cidade: cidade,
        contacto: contacto,
        email: email,
        paisId: pais,
        moedaId: moeda,
        linguaId: lingua,
        representante: responsavel,
        ax6: ax6,
        ax7: ax7,
    };
    return makeRequest(`/backend/clientes/Criar/${lang}`, params);
}

export function getArtigosPesquisa(pesquisa, indiceI, indiceF, lang, user) {
    let params = {
        pesquisa: pesquisa,
        indiceI: indiceI,
        indiceF: indiceF,
        user: user,
    };
    return makeRequest(`/backend/catalogo/pesquisa/${lang}`, params);
}

export function postInformacoesProposta(
    id,
    utilizador,
    layout,
    foto,
    texto,
    prazo,
    local,
    validade,
    obs,
    contactoAssinatura,
    imagemA,
    fornecimento,
    taxa1,
    taxa2,
    taxa3,
    pagamento,
    garantia,
    garantiaPT,
    garantiaM,
    contrato,
    lubrificantes,
    duracao,
    horasAno,
    precoHora,
    lang,
) {
    let params = {
        id: id,
        user: utilizador,
        layout: layout,
        claim: foto,
        despedida: texto,
        prazo: prazo,
        local: local,
        validade: validade,
        obs: obs,
        contactoAss: contactoAssinatura,
        imagemA: 0,
        fornecimento: fornecimento,
        taxa1: taxa1,
        taxa2: taxa2,
        taxa3: taxa3,
        pagamento: pagamento,
        garantia: garantia,
        garantiaPT: garantiaPT,
        garantiaM: garantiaM,
        contrato: contrato,
        lubrificantes: lubrificantes,
        duracao: duracao,
        horasAno: horasAno,
        precoHora: precoHora,
    };

    return makeRequest(`/backend/proposta/informacoes/${lang}`, params);
}

export function getInformacaoProposta(id, lang) {
    let params = {
        id: id,
    };

    return makeRequest(`/backend/proposta/informacoesProposta/${lang}`, params);
}

// export function getDadosInformacaoProposta(cliente, lang) {
//     return makeRequest(`/backend/proposta/dadosInformacoes/${cliente}/${lang}`);
// }

export function getOficinas(lang = 'POR') {
    return makeRequestGet(`/backend/oficinas/${lang}`);
}

export function getSubtipos(lang = 'POR') {
    return makeRequestGet(`/backend/negocios/subtipos/${lang}`);
}

// export function getEstados(lang) {
//     return makeRequest(`/backend/proposta/estados/${lang}`);
// }

export function getContactos(id, lang = 'POR') {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/negocios/contactos/${lang}`, params);
}

export function getVisitas(utilizador, indiceI, indiceF, lang) {
    let params = {
        utilizador: utilizador,
        indiceI: indiceI,
        indiceF: indiceF,
    };
    return makeRequest(`/backend/visitas/${lang}`, params);
}

export function getVisitasFiltros(user, pesquisa, indiceI, indiceF, lang) {
    let params = {
        user: user,
        pesquisa: pesquisa,
        indiceI: indiceI,
        indiceF: indiceF,
    };
    return makeRequest(`/backend/visitas/filtros/${lang}`, params);
}

export function getAcessoriosPropostas(id, lang = 'POR') {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/proposta/acessorios/${lang}`, params);
}

export function postAcessoriosPropostas(id, acessorio, preco, lang = 'POR') {
    let params = {
        id: id,
        nome: acessorio,
        preço: preco,
    };
    return makeRequest(`/backend/proposta/acessorios/Criar/${lang}`, params);
}

export function deleteAcessorios(id, lang = 'POR') {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/proposta/acessorios/delete/${lang}`, params);
}

export function getAtributos(id, lang = 'POR') {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/proposta/atributos/artigo/${lang}`, params);
}

export function getAtributosP(id, ref, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
    };
    return makeRequest(`/backend/proposta/atributos/proposta/${lang}`, params);
}

export function postAtributos(id, ref, linha, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
        linha: linha,
    };
    return makeRequest(`/backend/proposta/atributos/proposta/Criar/${lang}`, params);
}

export function eliminarAtributos(id, ref, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
    };
    return makeRequest(`/backend/proposta/atributos/proposta/delete/${lang}`, params);
}

export function getAcessoriosPropostaArtigo(id, ref, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
    };
    return makeRequest(`/backend/proposta/acessoriosP/${lang}`, params);
}

export function getAcessoriosProposta(id, lang = 'POR') {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/propostaAcessorios/${lang}`, params);
}

export function postAcessoriosPropostaArtigo(id, ref, linha, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
        linha: linha,
        quantidade: 0,
        preço: 0,
        desc: 0,
        total: 0,
    };
    return makeRequest(`/backend/proposta/acessoriosP/Criar/${lang}`, params);
}

export function postAcessoriosPropostaArtigo2(id, ref, linha, qtd, preco, desc, total, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
        linha: linha,
        quantidade: parseInt(qtd),
        preço: parseFloat(preco),
        desc: parseFloat(desc),
        total: parseFloat(total),
    };
    return makeRequest(`/backend/proposta/acessoriosP/Criar/${lang}`, params);
}

export function deleteAcessoriosPropostaArtigo(id, ref, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
    };
    return makeRequest(`/backend/proposta/acessoriosP/delete/${lang}`, params);
}

export function alterarAcessoriosPropostaArtigo(id, ref, linha, quantidade, preço, desc, total, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
        linha: linha,
        quantidade: parseInt(quantidade),
        preço: parseFloat(preço),
        desc: parseFloat(desc),
        total: parseFloat(total),
    };
    return makeRequest(`/backend/proposta/acessoriosP/update/${lang}`, params);
}

export function getCategoriasReunioes(lang) {
    return makeRequest(`/backend/reunioes/getCategorias/${lang}`);
}

export function getValidaNif(nif, lang = 'POR') {
    const params = {
        id: nif,
    };
    return makeRequest(`/backend/verificaNif/${lang}`, params);
}

export function getNifContacto(num, lang = 'POR') {
    const params = {
        id: num,
    };
    return makeRequest(`/backend/nifContacto/${lang}`, params);
}

export function getDadosProposta(lang) {
    return makeRequest(`/backend/orcamento/dados/${lang}`);
}

export function criarOrcamento(estabVenda, tipoOrcamento, data, cliente, estabExp, rep, artigos, ax5, ax7, projeto, lang = 'POR') {
    let params = {
        estabelecimentoVenda: estabVenda,
        tipoOrcamento: tipoOrcamento,
        data: data,
        cliente: cliente,
        estabelecimentoExpedicao: estabExp,
        representante: rep,
        artigos: artigos,
        aX5: ax5,
        aX7: ax7,
        projeto: projeto,
    };
    return makeRequest(`/backend/orcamento/Criar/${lang}`, params);
}

export function putOrcamento(idProposta, estabVenda, tipoOrcamento, data, cliente, estabExp, rep, artigos, ax5, ax7, projeto, lang = 'POR') {
    let params = {
        idProposta: idProposta,
        estabelecimentoVenda: estabVenda,
        tipoOrcamento: tipoOrcamento,
        data: data,
        cliente: cliente,
        estabelecimentoExpedicao: estabExp,
        representante: rep,
        artigos: artigos,
        aX5: ax5,
        aX7: ax7,
        projeto: projeto,
    };
    return makeRequest(`/backend/orcamento/Alterar/${lang}`, params);
}

export function eliminaLinhaOrcamento(id, linha, lang = 'POR') {
    const params = {
        linha: linha,
        id: id,
    };
    return makeRequest(`/backend/orcamento/elimina/${lang}`, params);
}

export function atualizaDadosOrcamento(idOriginal, idFinal, lang = 'POR') {
    const params = {
        numOriginal: idOriginal,
        numFinal: idFinal,
    };
    return makeRequest(`/backend/orcamento/Versoes/${lang}`, params);
}

export function atualizaDadosOrcamentoAposCriar(id, lang = 'POR') {
    const params = {
        id: id,
    };
    return makeRequest(`/backend/orcamento/atualizarCriar/${lang}`, params);
}

export function adjudicarOrcamento(idOriginal, idFinal, lang = 'POR') {
    const params = {
        numOriginal: idOriginal,
        numFinal: idFinal,
    };
    return makeRequest(`/backend/orcamento/adjudicar/${lang}`, params);
}

export function getEmail(id, lang = 'POR') {
    const params = {
        id: id,
    };
    return makeRequest(`/backend/propostaAcessorios/email/${lang}`, params);
}

export function putDadosOS(num, dataInicio, dataFim, utilizador, mecanico, lang = 'POR') {
    const params = {
        numPedido: num,
        dataInicio: dataInicio,
        dataFim: dataFim,
        utilizador: utilizador,
        mecanico: mecanico,
    };
    return makeRequest(`/backend/alteraDados/${lang}`, params);
}

export function getFuncoesContactos(lang) {
    return makeRequest(`/backend/prospects/funcoes/${lang}`);
}

export function postContactosProspect(num, array, lang = 'POR') {
    return makeRequest(`/backend/prospects/contactos/${num}/${lang}`, array);
}

// export function eliminarContactosProspect(num, lang = 'POR') {
//     return makeRequest(`/backend/prospects/elimina/contactos/${num}/${lang}`);
// }

export function getContactosProspect(num, lang) {
    return makeRequestGet(`/backend/prospects/contactos/${num}/${lang}`);
}

// export function getInfoExtraProspects(num, lang) {
//     return makeRequest(`/backend/prospects/info/${num}/${lang}`);
// }

export function postOrcamentoSemEfeito(num, lang = 'POR') {
    const params = {
        id: num,
    };
    return makeRequest(`/backend/orcamento/semEfeito/${lang}`, params);
}

export function getDespesas(utilizador, indiceI, indiceF, lang) {
    let params = {
        utilizador: utilizador,
        indiceI: indiceI,
        indiceF: indiceF,
    };

    return makeRequest(`/backend/despesas/${lang}`, params);
}

export function getDespesasFiltros(utilizador, utilizadorCriacao, estado, indiceI, indiceF, lang) {
    let params = {
        utilizador: utilizador,
        indiceI: indiceI,
        indiceF: indiceF,
        utilizadorCriacao: utilizadorCriacao,
        estado: estado,
    };
    return makeRequest(`/backend/despesas/filtros/${lang}`, params);
}

export function getDespesasPesquisa(user, pesquisa, indiceI, indiceF, lang) {
    let params = {
        user: user,
        pesquisa: pesquisa,
        indiceI: indiceI,
        indiceF: indiceF,
    };
    return makeRequest(`/backend/despesas/pesquisa/${lang}`, params);
}

export function getDespesaId(id, lang) {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/despesaID/${lang}`, params);
}

export function getAcessos(usr) {
    let params = {
        username: usr,
    };
    return makeRequest(`/backend/api/login/acessos`, params);
}

export function getEnderecosProspects(id, lang) {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/prospects/enderecos/${lang}`, params);
}

export function postupdUsr(utilizador, id, lang = 'POR') {
    let params = {
        id: utilizador,
        lang: id,
    };
    return makeRequest(`/backend/orcamento/updusr/${lang}`, params);
}

export function getContaCorrente(id, lang) {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/prospects/contaCorrente/${lang}`, params);
}

export function getVaidacaoNifPais(lang, pais) {
    return makeRequestGet(`/backend/nif/${lang}/${pais}`);
}

// export function getHistoricoVisitas(id, lang) {
//     let params = {
//         id: id,
//     };
//     return makeRequest(`/backend/prospects/visitas/${lang}`, params);
// }

export function getStatus(lang) {
    return makeRequestGet(`/backend/status/${lang}`);
}

export function putDespesa(id, status, lang = 'POR') {
    let params = {
        id: id,
        status: status,
    };
    return makeRequest(`/backend/putStatus/${lang}`, params);
}

export function enviarEmail(id, email, lang) {
    let params = {
        num: id,
        email: email,
    };
    return makeRequest(`/backend/pdf/${lang}`, params);
}

export function getHistorico(indiceI, indiceF, lang, search) {
    let params = {
        indiceI: indiceI,
        indiceF: indiceF,
        filtro: search,
    };
    return makeRequest(`/backend/ordem_servico/historico/${lang}`, params);
}

export function getUtilizadores(lang) {
    return makeRequestGet(`/backend/utilizadores/${lang}`);
}
